import { useNuxtApp } from '#app'
import type { RequestOptions } from '~/interfaces/request'
const useApi = (route = '') => {
  const { $api } = useNuxtApp()
  const uploadFile = async (data: Record<string, any>) => {
    const formData = new FormData()
    for (const key in data) {
      formData.append(key, data[key])
    }
    return await $api.post(`/${route}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }
  const customRequest = async (options: RequestOptions) => {
    const headers = {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    } as any
    if (options.withToken === false) {
      delete headers.Authorization
    }
    return await $api.request({
      method: options.method,
      url: options.url,
      data: options.data,
      params: options.params,
      headers,
      responseType: options.responseType || 'json',
    })
  }
  return {
    getAll: (params?: any) => $api.get(`/${route}`, { params }),
    getMyTicket: (params?: any) => $api.get(`/${route}/my-tickets`, { params }),
    get: (id: string, params?: any) => $api.get(`/${route}/${id}`, { params }),
    searchTicket: (id: string, data: any) =>
      $api.get(`/${route}/search-client`, { params: data }),
    getMe: () => $api.get(`/User/me`),
    updateProfile: (data: any) => $api.put(`/User/me`, data),
    create: (data: any) => $api.post(`/${route}`, data),
    update: (id: string, data: any) => $api.put(`/${route}/${id}`, data),
    remove: (id: string) => $api.delete(`/${route}/${id}`),
    cancelTicket: (id: string, params: any = {}) =>
      $api.patch(`/${route}/${id}/cancel`, {}, { params }),
    uploadFile,
    restore: (id: string) => $api.put(`/${route}/${id}/restore`),
    cancelBooking: (id: string) =>
      $api.patch(`/${route}/bookingCode/${id}/cancel`),
    changeStatusShare: (id: string, data: any) =>
      $api.put(`/${route}/${id}/is_public`, data),
    customRequest,
  }
}

export default useApi
